import apiService from '@/utils/api-client'
import config from "@/utils/appConfig"

export default {
  async addFiles(cntx, params) {
    return apiService.post(`files/store`, params, { baseURL: config.VUE_APP_API_FILES_BASE_URL })
      .then((data) => {
        return data
      })
      .catch((error) => {
        return error
      })
  },
}
